import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';
export function CountdownBar() {
  // Start at 14 minutes 39 seconds
  const [timeLeft, setTimeLeft] = useState(14 * 60 + 39);
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 0) {
          return 14 * 60 + 39; // Reset loop
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatTime = (seconds: number) => {
    const h = Math.floor(seconds / 3600);
    const m = Math.floor(seconds % 3600 / 60);
    const s = seconds % 60;
    return `${h.toString().padStart(2, '0')}:${m.toString().padStart(2, '0')}:${s.toString().padStart(2, '0')}`;
  };
  return <div className="sticky top-0 z-50 w-full bg-[#22c55e] text-white py-0.5 px-2 shadow-md text-center font-bold text-xs flex items-center justify-center gap-1" data-id="element-41">
      <Clock className="w-3 h-3 animate-pulse" data-id="element-42" />
      <span data-id="element-43">Oferta termina en: {formatTime(timeLeft)}</span>
    </div>;
}